module.exports = __webpack_public_path__ + "static/media/YM22_0.3dca9378.jpg";